import { Component, h } from 'preact';
import { connect } from 'react-redux';
import AnalysisSpread from './spreads/analysis';
import BottomLineSpread from './spreads/bottom-line';
import BreakthroughSpread from './spreads/breakthrough';
import CelticCrossSampleSpread from './spreads/celtic-cross-sample';
import CelticCrossSpread from './spreads/celtic-cross';
import HeartbreakSpread from './spreads/heartbreak';
import KarmicLessonsSpread from './spreads/karmic-lessons';
import HoroscopeTarotSpread from './spreads/horoscope-tarot';
import KarmaSpread from './spreads/karma';
import LifeCycleSpread from './spreads/life-cycle';
import MandalaSpread from './spreads/mandala';
import PeaceHarmonySpread from './spreads/peace-harmony';
import PotentialsSpread from './spreads/potentials';
import ReconciliationSpread from './spreads/reconciliation';
import RevelationSpread from './spreads/revelation';
import SelfKnowledgeSpread from './spreads/self-knowledge';
import SoulmateSpread from './spreads/soulmate';
import StarOfDavidSpread from './spreads/star-of-david';
import TimelineSpread from './spreads/timeline';
import TreeOfLifeSpread from './spreads/tree-of-life';
import TwoHeartsSpread from './spreads/two-hearts';
import YesOrNoSpread from './spreads/yes-or-no';

class TarotSpread extends Component {
    /* eslint-disable complexity */
    render({ positions, upc, view }) {
        let Spread = null;
        let attrs = {};

        if (positions.length == 12) {
            if (upc.match(/mandala/)) {
                Spread = MandalaSpread;
            } else {
                Spread = HoroscopeTarotSpread;
            }
        } else if (positions.length == 10) {
            if (upc.match(/analysis/)) {
                Spread = AnalysisSpread;
            } else if (upc.match(/tree-of-life/)) {
                Spread = TreeOfLifeSpread;
            } else {
                Spread = CelticCrossSpread;
            }
        } else if (positions.length == 9) {
            Spread = LifeCycleSpread;
        } else if (positions.length == 8) {
            if (upc.match(/soulmate/)) {
                Spread = SoulmateSpread;
            } else {
                Spread = YesOrNoSpread;
            }
        } else if (positions.length == 7) {
            Spread = PotentialsSpread;
        } else if (positions.length == 6) {
            if (upc.match(/star-of-david/)) {
                Spread = StarOfDavidSpread;
            } else {
                Spread = RevelationSpread;
            }
        } else if (positions.length == 5) {
            if (upc.match(/karma/)) {
                Spread = KarmaSpread;
            } else if (upc.match(/timeline/)) {
                Spread = TimelineSpread;
            } else if (upc.match(/reconciliation/)) {
                Spread = ReconciliationSpread;
            } else if (upc.match(/breakthrough/)) {
                Spread = BreakthroughSpread;
            } else {
                Spread = BottomLineSpread;
            }
        } else if (positions.length == 4) {
            Spread = MandalaSpread;
            if (upc.match(/balance/)) {
                attrs.type = 'balance';
            } else if (upc.match(/beginnings/)) {
                attrs.type = 'beginnings';
            } else if (upc.match(/changes/)) {
                attrs.type = 'changes';
            } else if (upc.match(/peace-harmony/)){
                Spread = PeaceHarmonySpread;
            }
        } else if (positions.length == 3) {
            if (upc.match(/heartbreak/)) {
                Spread = HeartbreakSpread;
            } else if (upc.match(/karmic-lessons/)) {
                Spread = KarmicLessonsSpread;
            } else if (upc.match(/self-knowledge/)) {
                Spread = SelfKnowledgeSpread;
            } else {
                Spread = CelticCrossSampleSpread;
            }
        } else if (positions.length == 2) {
            Spread = TwoHeartsSpread;
        } else if (positions.length == 1) {
            Spread = MandalaSpread;
            attrs.type = 'one-card';
        } else {
            Spread = CelticCrossSampleSpread;
        }

        return (
            <tarot-spread>
                <Spread {...attrs} view={view} />
            </tarot-spread>
        );
    }
    /* eslint-enable complexity */
}

const mapStateToProps = (state) => ({
    positions: state['tarot-reading'].positions,
    upc: state.product.teeup && state.product.teeup.code,
});

export default connect(mapStateToProps)(TarotSpread);
